import "./OregonMap.css";
import oregonMap from "../../images/oregon.jpg";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function OregonMap() {
  const navigate = useNavigate();

  const pins = [
    { name: "Columbia River", top: "15.2%", left: "28%", path: "/travel/oregoncolumbiariver" },
    { name: "Silver Fall State Park", top: "30.2%", left: "28%", path: "/travel/oregonsilverfalls" },

    // ⭐ Coast pins (auto-detected by path)
    { name: "Tunnel Beach", top: "17%", left: "9%", path: "/travel/oregoncoast#tunnelbeach" },
    { name: "Hungry Harbor", top: "23%", left: "8.5%", path: "/travel/oregoncoast#hungryharbor" },
    { name: "Devils Punch Bowl", top: "33%", left: "7.8%", path: "/travel/oregoncoast#devilspunchbowl" },
    { name: "Yaquina Lighthouse", top: "35.6%", left: "7.3%", path: "/travel/oregoncoast#yaquinalighthouse" },
    { name: "Heceta Lighthouse", top: "55%", left: "6.2%", path: "/travel/oregoncoast#hecetalighthouse" },
  ];

  const cycleRef = useRef(null);
  const indexRef = useRef(0);
  const pausedRef = useRef(false);
  const timeoutRef = useRef(null);

  const [activePin, setActivePin] = useState(null);

  // ⭐ Load last index on mount
  useEffect(() => {
    const savedIndex = localStorage.getItem("oregonMapIndex");
    if (savedIndex !== null) {
      indexRef.current = parseInt(savedIndex, 10);
    }
  }, []);

  // ⭐ Auto-cycle
  useEffect(() => {
    const pinNodes = document.querySelectorAll(".oregon-pin");

    const startCycle = () => {
      cycleRef.current = setInterval(() => {
        if (pausedRef.current) return;

        pinNodes.forEach((p) => p.classList.remove("active"));
        pinNodes[indexRef.current].classList.add("active");

        setActivePin(indexRef.current);

        localStorage.setItem("oregonMapIndex", indexRef.current);

        indexRef.current = (indexRef.current + 1) % pins.length;
      }, 2000);
    };

    startCycle();
    return () => clearInterval(cycleRef.current);
  }, [pins.length]);

  // ⭐ Desktop hover
  const handleHover = (index) => {
    pausedRef.current = true;
    setActivePin(index);
  };

  const handleLeave = () => {
    pausedRef.current = false;
  };

  // ⭐ Mobile touch
  const handleTouch = (index, event) => {
    if (event) event.preventDefault();

    pausedRef.current = true;
    setActivePin(index);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      pausedRef.current = false;
    }, 2000);
  };

  // ⭐ Stop cycle + navigate
  const handleNavigate = (path) => {
    pausedRef.current = true;
    clearInterval(cycleRef.current);
    navigate(path);
  };

  return (
    <div className="oregon-map-container">
      <img src={oregonMap} alt="Oregon Map" className="oregon-map" />

      {pins.map((pin, index) => {
        // ⭐ Auto-detect coast pins by checking the path
        const isCoast = pin.path.includes("oregoncoast");

        // ⭐ NEW: unique class per pin (based on name)
        const pinClass = `pin-${pin.name.replace(/\s+/g, "").toLowerCase()}`;

        return (
          <div
            key={index}
            className={`oregon-pin ${pinClass} ${isCoast ? "coast-pin" : ""} ${
              activePin === index ? "active" : ""
            }`}
            style={{ top: pin.top, left: pin.left }}
            onMouseEnter={() => handleHover(index)}
            onMouseLeave={handleLeave}
            onTouchStart={(e) => handleTouch(index, e)}
            onTouchEnd={(e) => handleTouch(index, e)}
            onClick={() => handleNavigate(pin.path)}
          >
            <div
              className="oregon-tooltip"
              onClick={(e) => {
                e.stopPropagation();
                handleNavigate(pin.path);
              }}
              onTouchStart={(e) => {
                e.stopPropagation();
                handleNavigate(pin.path);
              }}
              onTouchEnd={(e) => {
                e.stopPropagation();
                handleNavigate(pin.path);
              }}
            >
              {pin.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}
